// extracted by mini-css-extract-plugin
export default {"button":"Button_button__w+JtY","classic":"Button_classic__rwcze","primary":"Button_primary__ki19P","icon":"Button_icon__aYzeQ"};